import React from 'react';
import PortalBase from '@material-ui/core/Portal';

const Portal = (props) => <PortalBase {...props} />;

export default Portal;
